<div class="quantity-dialog">
  <div class="progress">
    <div class="total">
      <div class="label">{{ 'components.quantityDialog.total' | translate }}</div>
      <div class="total-quantity">{{ model.total }} {{ model.unit }}</div>
    </div>
    <div class="done">
      <form [formGroup]="quantityForm">
        <div class="label">{{ 'components.quantityDialog.done' | translate }}</div>
        <div class="quantity-placeholder">
          <mat-form-field class="whole quantity-form-field-placeholder">
            <input
              matInput
              id="whole"
              type="tel"
              formControlName="whole"
              autocomplete="off"
              #wholeInput
              (click)="wholeInput.select()"
            />
          </mat-form-field>
          <span>,</span>
          <mat-form-field color="primary" class="decimal quantity-form-field-placeholder">
            <input
              matInput
              id="decimal"
              type="tel"
              formControlName="decimal"
              autocomplete="off"
              #decimalInput
              (click)="decimalInput.select()"
              [maxLength]="2"
            />
          </mat-form-field>
        </div>
      </form>
    </div>
  </div>
  <div class="quantity-error-placeholder">
    @if (quantityForm.get('whole').hasError('min')) {
      <mat-error>
        <label for="whole"> The value for whole is lower than the minimum value </label>
      </mat-error>
    }
    @if (quantityForm.get('whole').hasError('pattern')) {
      <mat-error>
        <label for="decimal"> The whole value accepts only numbers </label>
      </mat-error>
    }
    @if (quantityForm.get('whole').hasError('required')) {
      <mat-error>
        <label for="whole"> Field cannot be empty </label>
      </mat-error>
    }
    @if (quantityForm.get('decimal').hasError('min')) {
      <mat-error>
        <label for="decimal"> The value for decimal is lower than the minimum value </label>
      </mat-error>
    }
    @if (quantityForm.get('decimal').hasError('max')) {
      <mat-error>
        <label for="decimal"> The value for decimal is greater than the maximum value </label>
      </mat-error>
    }
    @if (quantityForm.get('decimal').hasError('pattern')) {
      <mat-error>
        <label for="decimal"> The decimal value accepts only numbers </label>
      </mat-error>
    }
  </div>

  <div class="quick-actions">
    <div class="button-placeholder"><button mat-flat-button (click)="increaseValueBy(1)">+1</button></div>
    <div class="button-placeholder"><button mat-flat-button (click)="increaseValueBy(10)">+10</button></div>
    <div class="button-placeholder"><button mat-flat-button (click)="increaseValueBy(100)">+100</button></div>
    <div class="button-placeholder"><button mat-flat-button (click)="increaseValueBy(1000)">+1000</button></div>
    <div class="button-placeholder">
      <button mat-flat-button (click)="setValuesToTotal()">
        {{ 'components.quantityDialog.allDone' | translate }}
      </button>
    </div>
  </div>

  <div class="dialog-actions">
    <div class="dialog-actions-column">
      <button color="warn" mat-flat-button class="cancel" (click)="cancel()">
        {{ 'components.quantityDialog.cancel' | translate }}
      </button>
    </div>
    <div class="dialog-actions-column dialog-actions-column-right">
      <button color="primary" mat-flat-button class="confirm" [disabled]="canSubmit()" (click)="confirm()">
        {{ 'components.quantityDialog.confirm' | translate }}
      </button>
    </div>
  </div>
</div>
